<template>
  <div class="tradeManage">
    <div class="tradeManageBg">
      <div class="tradeHead">
        <el-form :inline="true" class="tradeSearch-form" ref="form">
          <el-form-item>
            <span class="tradeHead-title">客户用餐统计</span>
          </el-form-item>
          <el-form-item class="date">
            <el-date-picker
              style="width: 100%;"
              v-model="range"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="--"
              :clearable="true"
              clear-icon='el-icon-circle-close'
              start-placeholder="开始日期"
              end-placeholder="结束日期">
              <!-- <i slot="suffix" class="el-input__icon el-icon-circle-close" @click='clearInput'></i> -->
            </el-date-picker>
          </el-form-item>
          <el-form-item class="efi">
          <el-select 
            v-model="value"  
            @change="searchList"
          >
            <el-option label="全部" value='全部' ></el-option>
            <el-option 
              v-for="item in options" 
              :key='item.id'
              :label="item.name"
              :value="item.name"
            >{{item.name}}</el-option>
            <el-option label="空标签" value=''></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <!-- <el-button type="primary" @click="searchList" class="btn btnSubmit">查询</el-button> -->
          <!-- <el-button @click="resetForm()" class="btn btnReset">重置</el-button> -->
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="outExcel" class="excelBtn">导出报表</el-button>
        </el-form-item>
        </el-form>
      </div>
      <!-- <tradesearch v-on:billSearch="searchList($event)" v-on:timeChange="timeChange"></tradesearch> -->
      <dinnerTable :trade="tradeData"></dinnerTable> 
      <page
        v-on:clickPage="clickPage"
        :currentPage="currentPage"
        :pageSize ='size'
        :total="total"
      />
    </div>
  </div>
</template>
<script>
import dinnerTable from '@/components/dinnerTable';
import { getDinnerData, getTagData, getTableData, searchDinnerData } from '@/api/dinner';
import page from '../../components/PageIndex';
import { downloadExcel } from '@/utils/downloadFetch';
import {mapGetters} from 'vuex';
import {shop_url } from '@/global';
export default {
  components: {
    page,
    dinnerTable
  },
  data () {
    return {
      currentPage: 1,
      size: 10,
      clear: false,
      tradeData: [],
      total: 0,
      range: [],
      value: '全部',
      options: []
    }
  },
  computed: {
    ...mapGetters([
      'chooseCompany',
      'tradeCount',
      'tradeTotal'
    ])
  },
  created () {
    this._getList(1)
    this.getTags()
  },
  methods: {
    clearValue () {
      this.range = []
    },
    getTags () {
      let data = {
        // companyId: this.$store.getters.mchId,
        companyId: '4341658182878208'
      }
      getTagData(data).then(res => {
        console.log(res)
        this.options = res.data.data
      })
    },
    clickPage (val) {
      this.currentPage = val
      this._getList(val)
    },
    searchList () {
      this.currentPage = 1
      if (this.value == '全部') {
        let data = {
          page: this.currentPage,
          size: this.size,
          start: this.range[0] ? this.range[0]:'',
          companyId: this.$store.getters.mchId,
          end: this.range[1] ? this.range[1]:''
        }
        searchDinnerData(data).then(res => {
          console.log(res)
          this.tradeData = res.data.data.censusList
          this.total = res.data.data.count
        })
      } else {
        let data = {
          tag: this.value,
          page: this.currentPage,
          size: this.size,
          start: this.range[0] ? this.range[0]:'',
          companyId: this.$store.getters.mchId,
          end: this.range[1] ? this.range[1]:''
        }
        console.log(data)
          searchDinnerData(data).then(res => {
            console.log(res)
          this.tradeData = res.data.data.censusList
          this.total = res.data.data.count
        })
      }
    },
    _getList (page) {
      let data = {
        page: page,
        size: this.size,
        start: '',
        companyId: this.$store.getters.mchId,
        end: ''
      }
      console.log(data)
      // this.$store.dispatch('getTradeInfo',data)
      getDinnerData(data).then(res => {
        console.log(res)
        this.tradeData = res.data.data.censusList
        this.total = res.data.data.count
      })
    },
    outExcel () {
      // console.log(this.search)
      // let formDate = new FormData();
      // formDate.append('mchId', this.$store.getters.mchId);
      // formDate.append('type', this.search.type);
      // formDate.append('userId', (this.$store.getters.chooseCompany).userId);
      // formDate.append('start', this.search.range[0]);
      // formDate.append('end', this.search.range[1]);
      if (this.value == '全部') {
        let data = {
          // tag: this.form.value,
          // userId: (this.$store.getters.chooseCompany).userId,
          start: this.range[0],
          mchId: this.$store.getters.mchId,
          end: this.range[1]
        }
        console.log(data)
        downloadExcel({
          method: 'post',
          url: `${shop_url}/shop/mp/customer/census/print`,
          data: data,
          fileName: `${(this.$store.getters.chooseCompany).name}统计报表`
        }).then(res => {})
      } else if (this.value == '') {
        let data = {
          tag: this.value,
          // userId: (this.$store.getters.chooseCompany).userId,
          start: this.range[0],
          mchId: this.$store.getters.mchId,
          end: this.range[1]
        }
        downloadExcel({
          method: 'post',
          url: `${shop_url}/shop/mp/customer/census/print`,
          data: data,
          fileName: `${(this.$store.getters.chooseCompany).name}统计报表`
        }).then(res => {})
      } else {
        let data = {
          tag: this.value,
          // userId: (this.$store.getters.chooseCompany).userId,
          start: this.range[0],
          mchId: this.$store.getters.mchId,
          end: this.range[1]
        }
        downloadExcel({
          method: 'post',
          url: `${shop_url}/shop/mp/customer/census/print`,
          data: data,
          fileName: `${(this.$store.getters.chooseCompany).name}统计报表`
        }).then(res => {})
      }
    }
  },
  watch: {
    range (val) {
      console.log(val)
      if (val == null) {
        this.range = []
      }
      this.currentPage = 1
      if (this.value == '全部') {
        let data = {
          page: this.currentPage,
          size: this.size,
          start: this.range[0] ? this.range[0]:'',
          companyId: this.$store.getters.mchId,
          end: this.range[1] ? this.range[1]:''
        }
        searchDinnerData(data).then(res => {
          console.log(res)
          this.tradeData = res.data.data.censusList
          this.total = res.data.data.count
        })
      } else {
        let data = {
          tag: this.value,
          page: this.currentPage,
          size: this.size,
          start: this.range[0] ? this.range[0]:'',
          companyId: this.$store.getters.mchId,
          end: this.range[1] ? this.range[1]:''
        }
        console.log(data)
          searchDinnerData(data).then(res => {
            console.log(res)
          this.tradeData = res.data.data.censusList
          this.total = res.data.data.count
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/mixin.scss";
@import "../../style/_variables.scss";

.tradeManage {
  // width: 100%;
  margin: 0 16px;
  // background-color: #fff;
  // padding-top: 16px;
  // background-color: #e4e9ec;
  // margin-top: 50px;
}
.tradeSearch-form{
  display: flex;
  width:100%;
  justify-content: space-between;
}
.tradeManageBg {
  background-color: #fff;
}

.tradeHead {
  width: 99%;
  padding-top: 20px;
  @include flex-row;
  justify-content: space-between;
  .date{
    flex-basis: 32%;
  }
}

.tradeHead-title {
  margin-left: 30px;
  font-size: $font-18;
  color: $color-52;
}

.excelBtn {
  width: 126px;
  background-color: #0891d7;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/pages/AssetManagement/CustomersDinner.vue